import actions from "./actions";
import mutations from "./mutations.js";
import getters from "./getters.js";

const state = {
    clientId: -1,
    countriesSelect: [],
    countriesSelectPriceList: [],
    namesSelect: [],
    idNumberTypesSelect: [],
    priceLists: [],
    currentSaDepartment: null,
    selectedSaDepartment: {},
    errors: {},
    old: {},
    values: {}
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
};
